<template>
  <div class="modal fade" id="TypeRecetteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="TypeRecetteModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ selectedItem ? 'Modifier' : 'Ajouter' }} un type de recette</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="typeRecetteForm" @submit="soumettre" :validation-schema="typeRecetteSchema">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Libellé <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" v-model="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libellé" />
                  <ErrorMessage name="libelle" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">
                  {{ selectedItem ? 'Modifier' : 'Enregistrer' }}
                </button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { hideModal, showModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";

export default defineComponent({
  name: "TypeRecetteModal",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    item: {
      type: [String, Number, null],
      default: null,
    },
  },
  setup: (props, { emit }) => {
    const typeRecetteSchema = Yup.object().shape({
      libelle: Yup.string().required("Le libellé est obligatoire"),
    });

    const typeRecetteForm = ref<any | null>(null);
    const libelle = ref("");
    const selectedItem = ref<any>(null);
    const TypeRecetteModalRef = ref<null | HTMLElement>(null);

    const resetForm = () => {
      libelle.value = "";
      selectedItem.value = null;
    };

    const getTypeRecette = async (id: number | string) => {
      try {
        const response = await axios.get(`type/recette/${id}`);
        if (response.data && response.data.data) {
          const data = response.data.data;
          libelle.value = data.libelle || "";
          selectedItem.value = data;
        } else {
          error("Erreur lors de la récupération du type de recette");
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    watch(
      () => props.item,
      async (newValue) => {
        if (newValue !== null && newValue !== undefined) {
          await getTypeRecette(newValue);
        } else {
          resetForm();
        }
      },
      { immediate: true }
    );

    const soumettre = async (values, { resetForm }) => {
      try {
        let response;
        if (selectedItem.value && selectedItem.value.id) {
          // Mise à jour
          response = await axios.put(`type/recette/${selectedItem.value.id}`, values);
        } else {
          // Création
          response = await axios.post("type/recette", values);
        }
        
        if (response.data && response.data.code === 200) {
          success(response.data.message || (selectedItem.value ? "Type de recette modifié avec succès" : "Type de recette créé avec succès"));
          resetForm();
          hideModal(TypeRecetteModalRef.value);
          emit("close");
        }
      } catch (err) {
        if (err instanceof AxiosError) {
          error(err.response?.data?.message || "Une erreur est survenue");
        } else {
          error("Une erreur est survenue");
        }
      }
    };

    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const recharger = () => {
      // Ne rien faire
    };

    return {
      show_Modal,
      recharger,
      libelle,
      selectedItem,
      TypeRecetteModalRef,
      soumettre,
      typeRecetteSchema,
      typeRecetteForm,
    };
  },
});
</script>

